import axios from 'axios'
import React from 'react'

function ScrapperExport({ activeBody }) {
  const host = "https://objective-golick.108-175-10-21.plesk.page";


  async function exportCSV(ev) {
    ev.preventDefault();
    const value = ev.target.names.value;
    console.log(value);
    try {
      const response = await axios.post(`${host}/excel/download`, {
        value: value,
      }, {
        responseType: 'blob', // Importante para tratar la respuesta como un archivo binario
      });
  
      // Crear una URL para el Blob y descargar el archivo
      const url = window.URL.createObjectURL(new Blob([response.data]));
      
      const link = document.createElement('a');
      link.href = url;
  
      // Esto podría ser `response.headers['content-disposition']` para obtener el nombre de archivo
      link.setAttribute('download', `${value}.xlsx`); // Asegúrate de tener un nombre de archivo adecuado
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Error al descargar el archivo:', error);
    }
  }
  
  return (
    <div className={`Content__scraperForm--bodies-body ${activeBody === "exportarCSV" ? "activeBody" : ""}`}>
        <form onSubmit={exportCSV}>
            <div className="Content__scraperForm--inputTwoCols">
                <div className="Content__scraperForm--inputContainer">
                    <label htmlFor="names">Nombre del Producto o Marca</label>
                    <input type="text" name="names" id="names" />
                </div>
            </div>
            <div className="Content__scraperForm--sendButton">
                <button type="submit">Descargar Excel</button>
            </div>
        </form>
    </div>
  )
}

export { ScrapperExport }